export default __webpack_public_path__ + "static/media/Stryker_LateralIzq.3d045468.webp";